<span
  #spanRef
  [iuValidationDisplay]="data?.hasValidation"
  [iuValidationDisplay.datacontainer]="this"
  [iuValidationDisplay.iconIdx]="1"
  [iuValidationDisplay.inputSelector]="'.autocomplete-input-container'"
  [iuValidationDisplay.valid]="isValid()"
  [style.backgroundColor]="backgroundColorCss"
  [style.display]="displayCss"
  (contextmenu)="onContextMenu($event)"
  (press)="onContextMenu($any($event))">
  <iu-prime-autocomplete
    #autoComplete
    [appendTo]="appendTo"
    [columnName]="columnName"
    [componentType]="componentType"
    [data]="data"
    [dataStored]="dataStored"
    [description]="tooltip"
    [disabled]="isReadOnly"
    [dropdown]="true"
    [iconClass]="iconClass"
    [isEditorView]="isEditorView"
    [isInsideOverflow]="isInsideOverflow"
    [isLabelDisplay]="this.isLabelDisplay"
    [isStandalone]="isStandalone"
    [label]="label"
    [multiple]="multiple"
    [ngClass]="[hasConflict ? 'iu-field-conflict' : '']"
    [overridedCSS]="overridedCSS"
    [placeholder]="placeholder"
    [preventLabelClick]="preventZoom()"
    [readonly]="isReadOnly"
    [scrollHeight]="scrollHeight"
    [styleLess]="styleLess()"
    [suggestions]="suggestions"
    [suggestionsFilter]="suggestionsFilter"
    [tabID]="data?.tabId"
    (click)="onInputClick($event)"
    (completeMethod)="search($event)"
    (mousedown)="onMouseDown($event)"
    (onBlur)="blurEmitter.emit($event)"
    (onFocus)="search($event)"
    (onLabelClickEmitter)="zoomAcross()"
    (onSelect)="dataChange(autoComplete.value)"
    (onUnselect)="dataChange(autoComplete.value)"
    (showFormPanelEmitter)="showFormPanel($event)"
    (showSearchPanelEmitter)="showSearchPanel()" />
  @if (hasConflict && dataStored) {
    <i
      #spanInput
      aria-hidden="true"
      class="rtconflict fas fa-exclamation-triangle iconClass iu-field-conflict-icon"
      (click)="showConflictPanel($event)"></i>
  }
  @if (showValuePrefPanel) {
    <iu-prime-overlay #opValuePref appendTo="body" [dismissable]="true">
      <iu-value-preference-panel
        [data]="this.data"
        [dataStored]="this.dataStored"
        [fieldValue]="fieldValue"
        [overlayPanel]="opValuePref"
        [sourceComponent]="this"
        (closeEmitter)="toggleValuePreferencePanel($event)" />
    </iu-prime-overlay>
  }
</span>

<iu-prime-overlay #opConflict>
  <a class="data-conflict" (click)="chooseData($event, (dataStored?.data)[data.columnName], true); opConflict.hide()">
    {{ (dataStored?.data)[data.columnName]?.displayValue }}
  </a>
  |
  <a class="data-conflict" (click)="chooseData($event, conflictedData, false); opConflict.hide()">
    {{ conflictedData?.displayValue }}
  </a>
</iu-prime-overlay>

@if (displaySearch) {
  <iu-modal-ui
    data-cy="search-panel"
    [appendTo]="'body'"
    [attr.data-cy-columnName]="data.columnName"
    [hasCloseBtn]="true"
    [title]="label"
    (closeModalEmitter)="hideSearchPanel()">
    <ng-template #autocompleteUniversalFilter>
      <div class="autocomplete-universal-filter" style="--az-panel-z-index: 10000">
        <iu-universal-filter-ui [gridTab]="gridTab" />
      </div>
    </ng-template>
    <apiz-toolbar [filterTplRef]="autocompleteUniversalFilter" />
    <iu-grid-tab-infinity-scroll-headless-ui
      #gridTab
      [container]="parentContainer"
      [data]="data"
      [dataStored]="standaloneCtx() ?? dataStored"
      [getCurrentContext]="getCurrentContext"
      [isInUniversalFilter]="isInUniversalFilter"
      [isSearch]="true"
      [validation]="searchPanelValidation"
      [windowType]="windowType"
      (searchEmitter)="this.setSearchSelectItem($event); searchPanelValidation = undefined" />
  </iu-modal-ui>
}
@if (displayFormUI) {
  <div [ngClass]="[!displayFormUI ? 'hidden' : '', 'specificModal']">
    <iu-modal-ui
      #specificModal
      [angularStyle]="customFormModalBodyCss"
      [appendTo]="'body'"
      [isModalDisplay]="displayFormUI"
      [title]="specificWindowTitle"
      (closeModalEmitter)="updateModalDisplay({ display: { key: 'displayFormUI', value: false }})">
      <ng-template #vcrSpecific />
    </iu-modal-ui>
  </div>
}
